<template>
  <div style="margin-top: -40px !important" v-if="resource">
    <head>
      <link
        href="https://fonts.googleapis.com/css?family=Roboto:100,300,400,500,700,900"
        rel="stylesheet"
      />
      <!--      <link href="https://cdn.jsdelivr.net/npm/@mdi/font@4.x/css/materialdesignicons.min.css" rel="stylesheet">-->
      <!--      <link href="https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css" rel="stylesheet">-->
      <!--      <meta name="viewport" content="width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no, minimal-ui">-->
    </head>
    <b-container class="pt-0">
      <!-- Successful resource share modal -->
      <b-modal id="modal-1" title="Success" ok-only>
        <p class="my-2">
          This ingredient is shared with the user you have chosen!
        </p>
      </b-modal>
      <b-modal id="modal-2" title="Success" ok-only>
        <p class="my-2">
          This ingredient is shared with the group you have chosen!
        </p>
      </b-modal>
      <!-- Share Resource  Modal -->
      <b-modal
        id="modal-prevent-closing"
        ref="modal"
        v-bind:title="'Share this ingredient ' + this.title"
        ok-variant="danger"
        ok-title="Share"
        @cancel="hideModal"
        @ok="handleOk"
      >
        <form ref="form" @submit.stop.prevent="handleSubmit">
          <div class="container">
            <b-form-group
              label="Do you wish to share this resource with a single user or a group?"
            >
              <!--              <b-form-radio-group id="radio-group-2" v-model="selected" @input="showConsole" name="radio-sub-component">-->
              <b-form-radio-group
                id="radio-group-2"
                v-model="selected"
                name="radio-sub-component"
              >
                <b-form-radio value="a">a single user</b-form-radio>
                <b-form-radio value="b">a group</b-form-radio>
              </b-form-radio-group>
            </b-form-group>

            <b-form-group v-if="this.selected === 'a'">
              <p class="my-2">Whom would you like to share this with?</p>

              <Autocomplete :EventBus="sendChosenLogin1"></Autocomplete>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyLoginAlert"
                variant="danger"
              >
                This UserName is invalid!
              </b-alert>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="notFoundUserAlert"
                variant="danger"
              >
                An error occurred! Maybe the UserName you submitted does not
                exist!
              </b-alert>
            </b-form-group>

            <b-form-group
              v-if="this.selected === 'b'"
              label="Which group would you like to share this resource with?"
              label-align="left"
            >
              <b-form-input
                style="width: 100%"
                v-model="GroupChosen"
                placeholder="Enter the Group name"
              >
              </b-form-input>

              <b-alert
                dismissible
                style="width: 100%"
                v-model="emptyGroupNameAlert"
                variant="danger"
              >
                This group name is invalid!
              </b-alert>
              <b-alert
                dismissible
                style="width: 100%"
                v-model="notFoundGroupAlert"
                variant="danger"
              >
                An error occured! Maybe the group you submitted does not exist!
              </b-alert>
            </b-form-group>
          </div>

          <hr />

          <b-form-group
            class="col-12"
            label="What right will you grant to this user?"
            label-align="left"
          >
            <b-form-select :options="Rights" v-model="right"> </b-form-select>
            <b-alert
              dismissible
              style="width: 100%"
              v-model="emptyRightAlert"
              variant="danger"
            >
              You have to specify the right!
            </b-alert>
          </b-form-group>
        </form>
      </b-modal>

      <div class="mt-lg-5">
        <!-- Basic information -->
        <div class="row pt-4 pb-4 bg-white border-custom-lgr">
          <div class="col-lg-5 col-sm-5 col-md-5 col-xs-12">
            <div
              class="text-left p-3"
              v-if="resource.url && resource.mediaType === 'Image'"
            >
              <span>
                <b-img :src="resource.url" class="mb-2" fluid-grow> </b-img>
                <br />
              </span>
            </div>
            <!-- if not img -->
            <div class="text-left p-5 bg-gray" id="image-container" v-else>
              <div class="col-4"></div>
              <div class="col-4 pl-lg-5">
                <span class="pl-lg-5" :style="adjustColor(resource.mediaType)">
                  <font-awesome-icon
                    :icon="adjustIcon(resource.mediaType)"
                    size="10x"
                  />
                </span>
              </div>
              <div class="col-4"></div>
            </div>
            <div class="text-muted text-left p-3">
              <span
                title="Creation date of the ingredient"
                v-b-tooltip.hover.bottom
              >
                <font-awesome-icon icon="calendar-alt" />
                {{ resource.created | utcLocalDatetime }}
              </span>
            </div>
            <div
              v-if="
                this.$store.state.user.login !== this.resource.creator.login
              "
            >
              <div
                v-if="!this.ratingSubmitted ? 'background-color: green' : null"
                class="pl-3 row"
              >
                <div>
                  <p style="font-weight: bold">
                    {{
                      initialRating === ""
                        ? "Rate this ingredient:"
                        : "Your rating:"
                    }}
                  </p>
                </div>
                <div>
                  <v-app
                    style="height: 50px; margin-top: -20px; background: white"
                  >
                    <div class="text-left">
                      <v-rating
                        v-model="userRating"
                        background-color="orange lighten-3"
                        color="orange"
                        large
                      ></v-rating>
                    </div>
                  </v-app>
                </div>
              </div>
              <div
                v-if="!this.ratingSubmitted"
                style="z-index: 3; position: relative; margin-top: -10px"
                class="pl-3 row"
              >
                <b-form-textarea
                  v-model="userRatingComment"
                  placeholder="Say something about this ingredient"
                ></b-form-textarea>
                <b-button
                  @click="submitRating"
                  class="mt-1 bg-orange"
                  size="sm"
                >
                  {{ initialRating === "" ? "Submit " : "Edit your " }}rating
                </b-button>
              </div>
              <p
                v-if="ratingSubmitted"
                class="text-left mt-1 pl-3"
                style="color: green"
              >
                Submitted!
              </p>
            </div>
          </div>

          <div class="col-lg-7 col-sm-7 col-md-7 col-xs-12">
            <div class="p-3">
              <h4 class="text-left mb-4">
                <strong style="overflow-wrap: break-word">{{
                  resource.title
                }}</strong>
                <span v-show="isEditable || isDeletable"> |</span>
                <small>
                  <router-link
                    :to="{
                      name: 'resourceEdit',
                      params: { id: this.$route.params.id },
                    }"
                    class="text-dark"
                    title="Edit the ingredient"
                    v-b-tooltip.hover.top
                    v-show="isEditable"
                  >
                    <b-button class="btn btn-sm btn-dark">
                      <font-awesome-icon icon="edit" />
                      Edit
                    </b-button>
                  </router-link>
                  <b-link
                    @click.prevent="showMsgDelete(resource.id, resource.title)"
                    class="text-danger"
                    title="Delete the ingredient"
                    v-b-tooltip.hover.top
                    v-if="isDeletable"
                  >
                    <b-button class="btn btn-danger btn-sm">
                      <font-awesome-icon icon="trash-alt" />
                      Delete
                    </b-button>
                  </b-link>
                  <b-link
                    v-show="isShareable"
                    class="text-info"
                    title="Share the ingredient"
                    v-b-tooltip.hover.top
                  >
                    <b-button
                      @click="ShareThisResource"
                      class="btn btn-sm btn-info"
                    >
                      <font-awesome-icon icon="share-alt" />
                      Share
                    </b-button>
                  </b-link>
                  <b-link
                    class="text-white"
                    title="Favorite"
                    v-b-tooltip.hover.top
                  >
                    <span
                      @click="handleBookmarkResource(resource)"
                      class="container"
                    >
                      <i
                        style="color: red"
                        :class="
                          resource.bookmarked ? 'fas fa-heart' : 'far fa-heart'
                        "
                      ></i>
                    </span>
                  </b-link>
                </small>
              </h4>
              <div class="row">
                <v-app
                  style="height: 50px; margin-top: -20px; background: white"
                >
                  <div class="text-left">
                    <v-rating
                      v-model="averageRating"
                      background-color="orange lighten-3"
                      color="orange"
                      large
                      half-increments
                      readonly
                    ></v-rating>
                  </div>
                </v-app>
                <div class="pl-2">
                  <p>
                    Average rating: <strong>{{ averageRatingStars }}/5</strong>
                  </p>
                </div>
                <div class="pl-2 mb-4">
                  <b-link @click.prevent="scrollTo('ratings')" href="#">
                    <button
                      @click="getRatings"
                      class="btn btn-sm btn-outline-info"
                    >
                      See ratings
                    </button>
                  </b-link>
                </div>
              </div>
              <span style="position: relative; z-index: 3">
                <h4 class="text-left mb-4">
                  <span title="Added by" v-b-tooltip.hover.bottom>
                    <font-awesome-icon icon="user-cog" size="1x" />
                    {{ resource.creator.login }}
                  </span>
                </h4>
                <p class="text-left mb-4">
                  <span
                    v-if="resource.contentLanguage"
                    title="Content language of the ingredient"
                    v-b-tooltip.hover.bottom
                  >
                    <font-awesome-icon icon="language" size="lg" />
                    {{ getResourceLanguage() }}
                  </span>
                  <br />
                  <br />
                  <span
                    v-if="resource.license"
                    title="License of the resource"
                    v-b-tooltip.hover.bottom
                  >
                    <font-awesome-icon icon="id-badge" size="lg" />
                    {{ getResourceLicense() }}
                  </span>
                  <span
                    v-if="resource.mediaType"
                    title="Media type of the resource"
                    v-b-tooltip.hover.bottom
                  >
                    <font-awesome-icon icon="photo-video" size="lg" />
                    {{ resource.mediaType }}
                  </span>
                </p>
                <p class="text-left mb-4">
                  <span
                    title="Visibility of the ingredient"
                    v-b-tooltip.hover.bottom
                  >
                    <span class="font-weight-bold">Visibility:</span>
                    {{ visibility }}
                  </span>
                  <br />
                  <br />
                  <span
                    title="What type of ingredient is it?"
                    v-b-tooltip.hover.bottom
                  >
                    <span v-if="resource.resourceType" class="font-weight-bold"
                      >Ingredient type:</span
                    >
                    {{ getResourceType() }}
                  </span>
                </p>
                <p v-if="resource.url" class="text-left mb-4">
                  <span>
                    <b-button
                      v-b-tooltip.hover.bottom
                      title="Route to the ingredient"
                      class="btn bg-orange btn-sm"
                      :href="getResourceLink()"
                      target="_blank"
                      >Route to the ingredient &nbsp;<font-awesome-icon
                        :icon="adjustIcon(resource.mediaType)"
                        size="lg"
                      />
                    </b-button>
                  </span>
                </p>
                <p
                  style="overflow-wrap: break-word"
                  title="Ingredient's description"
                  class="text-left mb-4"
                  v-b-tooltip.hover.left
                >
                  {{ resource.description }}
                </p>
                <p class="text-left" v-if="existKeywords">
                  <Keywords
                    type="ingredient"
                    title="Keywords"
                    :keywords="resource.keywords"
                    id="keywords-list"
                    v-b-tooltip.hover.left
                  />
                </p>
              </span>
            </div>
          </div>
        </div>
        <br />
        <!-- 2nd banner -->
        <div class="row mt-3">
          <!-- creators -->
          <div
            class="col-lg-4 col-sm-4 col-md-12 col-xs-12 pt-3 border-custom-lgr min-h-250 col-container bg-white"
          >
            <h4 class="text-left pl-3">Creators</h4>
            <hr />
            <!-- Creators With ID -->
            <div v-if="resource.creatorsWithId" class="mb-2">
              <div
                v-for="collaborator in resource.creatorsWithId"
                class="pl-3 pr-3 pb-0"
                :key="collaborator.name"
              >
                <p
                  :title="collaborator.description"
                  class="text-left"
                  v-b-tooltip.hover.bottom
                >
                  <font-awesome-icon icon="landmark" class="mr-2" />
                  <router-link
                    :to="{
                      name: 'organizationView',
                      params: { id: collaborator.id },
                    }"
                  >
                    <span
                      style="overflow-wrap: break-word"
                      v-if="collaborator.name"
                    >
                      {{ collaborator.name }}
                    </span>
                    <span v-else> Unknown </span>
                  </router-link>
                </p>
              </div>
            </div>
            <!-- Creators Without ID -->
            <div v-if="resource.creators" class="mb-2">
              <div
                v-for="creator in resource.creators"
                class="pl-3 pr-3 pb-0"
                :key="creator.name"
              >
                <p
                  :title="creator.description"
                  class="text-left"
                  v-b-tooltip.hover.bottom
                >
                  <font-awesome-icon icon="landmark" class="mr-2" />
                  <!--                  <router-link :to="{name: 'organizationView', params: { id: creator.id }}">-->
                  <span style="overflow-wrap: break-word" v-if="creator.name">{{
                    creator.name
                  }}</span>
                  <span v-else>Unknown</span>
                </p>
              </div>
            </div>
            <!-- No creators (no creators with ID && no creators without ID - the field resource.creators
            is always returned, so instead of checking its existence, we shall check its length because it is an array) -->
            <div
              v-if="!resource.creatorsWithId && resource.creators.length === 0"
            >
              <p class="text-left p-2">Not defined</p>
            </div>
          </div>
          <!-- areas of focus  -->
          <div
            class="col-lg-4 col-sm-4 col-md-12 col-xs-12 pt-3 border-custom-lgr min-h-250 col-container bg-white"
          >
            <h4>Areas of focus</h4>
            <hr />
            <div v-if="resource.areasOfFocus">
              <div
                v-for="topic in resource.areasOfFocus"
                class="pl-3 pr-3 pb-0"
                v-bind:key="topic"
              >
                <p v-if="topic !== 'Other'" class="text-left">
                  <font-awesome-icon
                    icon="hand-point-right"
                    size="lg"
                    class="mr-2"
                  />
                  {{ topic }}
                </p>
              </div>
            </div>
            <div v-else>
              <p class="text-left p-2">Not defined</p>
            </div>
          </div>
          <!-- notes -->
          <div
            v-if="resource.notes"
            class="col-lg-4 col-sm-4 col-md-12 col-xs-12 pt-3 border-custom-lgr min-h-250 bg-white"
          >
            <!--            <h4>Notes</h4>-->
            <h4>Notes</h4>
            <hr />
            <div v-if="resource.notes" class="text-left">
              {{ resource.notes }}
            </div>
            <div v-else>
              <p class="text-left p-2">Not defined</p>
            </div>
          </div>
        </div>
      </div>

      <!-- ratings -->
      <div
        ref="ratings"
        v-if="ratingCommentsSectionShow"
        class="row mt-3 pb-4 bg-white border-custom-lgr"
      >
        <div class="col-lg-12 col-sm-12 col-md-12 col-xs-12 pt-3">
          <h4 class="text-left pl-3">Ratings</h4>
          <hr />
          <div v-for="rating in ratings">
            <Rating :rating="rating"></Rating>
          </div>
          <div class="overflow-auto" v-if="showPagination">
            <b-pagination
              v-model="pagination.currentPage"
              :total-rows="pagination.totalCount"
              :per-page="pagination.pageSize"
              first-text="First"
              prev-text="Prev"
              next-text="Next"
              last-text="Last"
              align="center"
              @input="getRatings"
            >
            </b-pagination>
          </div>
        </div>
      </div>

      <div
        v-if="
          resource.creator !== '' &&
          (resource.rights === 'OWN' ||
            resource.rights === 'READ' ||
            resource.rights === 'WRITE')
        "
        class="comments"
      >
        <VueDisqus shortname="culturelabs-1" :identifier="$route.path" />
      </div>
    </b-container>
  </div>
  <div v-else>
    <NoAccess />
  </div>
</template>

<script>
import Keywords from "../components/Keywords";
import NoAccess from "../components/NoAccess";
import Autocomplete from "./Autocomplete";
import Rating from "../components/Rating";
import { mapGetters } from "vuex";
import { eventBus } from "../main";
import axios from "axios";
import { Disqus } from "vue-disqus";

export default {
  name: "resourceView",
  components: {
    Rating,
    Keywords,
    Autocomplete,
    NoAccess,
    Disqus,
  },
  data() {
    return {
      resource: {
        creator: "",
        creatorsWithId: [],
        rights: "",
        resourceType: [],
      },
      ratingSubmitted: false,
      ratings: "",
      ratingCommentsSectionShow: false,
      userRating: "",
      userRatingComment: "",
      initialRating: "",
      imageResourceUrl: null,
      emptyLoginAlert: false,
      emptyGroupNameAlert: false,
      emptyRightAlert: false,
      notFoundUserAlert: false,
      notFoundGroupAlert: false,
      sendChosenLogin1: "sendChosenLogin",

      selected: "a",
      GroupChosen: "",
      GroupChosenId: "",

      title: "",
      userLogin: null,
      userID: 0,
      right: null,
      users: "",
      Rights: [
        { text: "I will grant the right to ...", value: null },
        { text: "View the ingredient", value: "READ" },
        { text: "Edit the ingredient", value: "WRITE" },
      ],
      value1: "",

      pagination: {
        currentPage: 1,
        totalCount: 0,
        pageSize: 10,
      },
      bookmarked: "",
    };
  },
  watch: {
    $route(to, from) {
      if (from.params.id && to.params.id) {
        this.$router.go(to);
      }
    },
  },
  created: function () {
    // get the resource
    this.getResource(this.$route.params.id);
    eventBus.$on("sendChosenLogin", (value11) => {
      this.value1 = value11;
    });
    this.getUserRating(this.$route.params.id);
  },
  computed: {
    ...mapGetters(["authenticatedUser"]),
    showPagination: function () {
      // display or not the pagination bar
      return this.pagination.totalCount > this.pagination.pageSize;
    },
    averageRating() {
      let rating = this.resource.avgRatingx100;
      if (rating < 50) return 0;
      else if (rating >= 50 && rating < 100) return 0.5;
      else if (rating >= 100 && rating < 150) return 1;
      else if (rating >= 150 && rating < 200) return 1.5;
      else if (rating >= 200 && rating < 250) return 2;
      else if (rating >= 250 && rating < 300) return 2.5;
      else if (rating >= 300 && rating < 350) return 3;
      else if (rating >= 350 && rating < 400) return 3.5;
      else if (rating >= 400 && rating < 450) return 4;
      else if (rating >= 450 && rating < 500) return 4.5;
      else if (rating === 500) return 5;
    },
    averageRatingStars() {
      if (this.resource.avgRatingx100 === -1) return "-";
      else return Math.max(0, this.resource.avgRatingx100 / 100);
    },
    isShared() {
      // check if the resource is shared
      return this.resource.isShared;
    },
    isEditable() {
      // check if edit action is allowed
      return this.resource.rights === "OWN" || this.resource.rights === "WRITE";
    },
    isDeletable() {
      // check if delete action is allowed
      // return !this.isShared
      return this.resource.rights === "OWN";
    },
    isShareable() {
      // check if share action is allowed
      return this.resource.rights === "OWN";
    },
    visibility() {
      return this.resource.publicReadable === true ? "Public" : "Private";
    },
    isImplemented() {
      if (this.resource.implemented) {
        return "check-circle";
      } else {
        return "times-circle";
      }
    },
    hideBanner2() {
      // Hide the division that displays the collaborators, areasOfFocus and targetGroup only
      // and if only these are not defined
      return !(
        this.resource.creatorsWithId &&
        this.resource.areasOfFocus &&
        this.resource.targetGroup
      );
    },
    hideBanner3() {
      // Hide the division that displays the collaborators, areasOfFocus and targetGroup only
      // and if only these are not defined
      return !(
        this.resource.ingredients &&
        this.resource.steps &&
        this.resource.challenges
      );
    },
  },
  methods: {
    getResourceType() {
      if (
        this.resource.resourceType.length > 1 &&
        this.resource.resourceType.includes("Other")
      ) {
        let index = this.resource.resourceType.indexOf("Other");
        this.resource.resourceType.splice(index, 1);
      }
      return this.resource.resourceType.join(", ");
    },
    getResourceLanguage() {
      if (this.resource.contentLanguage.includes("Other")) {
        if (
          this.resource.contentLanguage[
            this.resource.contentLanguage.length - 1
          ] !== ""
        ) {
          // If 'Other' is selected and the next value is not empty (deleted)
          let index = this.resource.contentLanguage.indexOf("Other");
          this.resource.contentLanguage.splice(index, 1);
          return this.resource.contentLanguage.join(", ");
        } else {
          return this.resource.contentLanguage[0];
        }
      }
      return this.resource.contentLanguage.join(", ");
    },
    getResourceLicense() {
      if (
        this.resource.license.includes("Other") &&
        this.resource.license.length > 1
      ) {
        let index = this.resource.license.indexOf("Other");
        this.resource.license.splice(index, 1);
      }
      return this.resource.license.join(", ");
    },
    ShareThisResource() {
      this.$bvModal.show("modal-prevent-closing");
    },
    hideModal() {
      //   this.recipeID = 0
      this.value1 = "";
      this.selected = "a";
      this.right = null;
      this.notFoundUserAlert = false;
      this.notFoundGroupAlert = false;
      this.emptyRightAlert = false;
      this.emptyLoginAlert = false;
      this.emptyGroupNameAlert = false;
      this.GroupChosen = "";
    },
    handleSubmit() {
      if (this.selected === "b") {
        this.emptyRightAlert = false;
        this.emptyGroupNameAlert = false;
        this.notFoundGroupAlert = false;

        // Exit when the form isn't valid
        if (this.GroupChosen === null || this.GroupChosen === "") {
          this.emptyGroupNameAlert = true;
        } else if (this.GroupChosen !== null && this.GroupChosen !== "") {
          this.emptyGroupNameAlert = false;

          axios
            .get("/group/byName?name=" + this.GroupChosen, {
              withCredentials: true,
            })
            .then((response) => {
              this.GroupChosenId = response.data.id;
              this.notFoundGroupAlert = false;
              if (this.right === "" || this.right === null) {
                this.emptyRightAlert = true;
              } else {
                this.SendUserDataToAPI();
              }
            })
            .catch((err) => {
              console.log(err);
              this.emptyGroupNameAlert = false;
              this.notFoundGroupAlert = true;
              this.userID = "";
            });
        }
      }

      if (this.selected === "a") {
        this.emptyRightAlert = false;
        this.emptyLoginAlert = false;
        this.notFoundUserAlert = false;

        // Exit when the form isn't valid
        if (this.value1 === null || this.value1 === "") {
          this.emptyLoginAlert = true;
          this.value1 = "";
        } else if (this.value1 !== null && this.value1 !== "") {
          this.emptyLoginAlert = false;
          axios
            .get(
              "/user/byLogin?login=" + this.value1,

              { withCredentials: true }
            )
            .then((response) => {
              this.userID = response.data.id;
              this.notFoundUserAlert = false;

              if (this.right === "" || this.right === null) {
                this.emptyRightAlert = true;
              } else {
                this.SendUserDataToAPI();
              }
            })
            .catch((err) => {
              console.log(err);
              this.emptyLoginAlert = false;
              this.notFoundUserAlert = true;
              this.userID = "";
            });
        }
      }
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault();
      // Trigger submit handler
      this.handleSubmit();
    },
    SendUserDataToAPI() {
      if (this.selected === "a") {
        axios
          .post(
            "/share/Resource/" +
              this.$route.params.id +
              "?userId=" +
              this.userID +
              "&right=" +
              this.right,
            null,

            { withCredentials: true }
          )
          .then((response) => {
            console.log(response);
            this.recipeID = 0;
            this.value1 = "";
            this.right = null;
            this.notFoundUserAlert = false;
            this.emptyRightAlert = false;
            this.emptyLoginAlert = false;
            this.$bvModal.hide("modal-prevent-closing");
            this.$bvModal.show("modal-1");
          });
      }

      if (this.selected === "b") {
        axios
          .post(
            "/share/Resource/" +
              this.$route.params.id +
              "?groupId=" +
              this.GroupChosenId +
              "&right=" +
              this.right,
            null,

            { withCredentials: true }
          )
          .then((response) => {
            this.recipeID = 0;
            this.GroupChosenId = "";
            this.value1 = "";
            this.right = null;
            this.notFoundUserAlert = false;
            this.emptyRightAlert = false;
            this.emptyLoginAlert = false;
            this.$bvModal.hide("modal-prevent-closing");
            this.$bvModal.show("modal-2");
          });
      }
    },
    getResourceLink() {
      let link = this.resource.url;
      if (link && (link.startsWith("http") || link.startsWith("www"))) {
        return link;
      }
      return "#";
    },
    scrollTo(refName) {
      let element = this.$refs[refName];
      let top = element.offsetTop;
      window.scrollTo({
        top: top,
        left: 0,
        behavior: "smooth",
      });
    },
    initRatings() {
      this.ratings = [];
    },
    getRatings() {
      this.ratingCommentsSectionShow = true;
      let params = {
        id: this.$route.params.id,
        start: this.pagination.pageSize * (this.pagination.currentPage - 1),
        count: this.pagination.pageSize,
      };
      // get data
      let tempResources = [];
      this.$store.dispatch("getResourceCurrentRatings", params).then((data) => {
        tempResources = data;
        this.pagination.totalCount = data.length;
        this.initRatings();
        // adjust rating entities
        tempResources.forEach((rating) => {
          let temp = rating;
          this.ratings.push(temp);
        });
        console.log(this.ratings);
      });
    },
    hideRatingSubmitted() {
      this.ratingSubmitted = false;
    },
    updateAverageRating() {
      this.getResource(this.resource.id);
    },
    submitRating() {
      let ratingObj = {
        recipeId: this.$route.params.id,
        stars: this.userRating,
        comment: this.userRatingComment,
      };
      if (this.initialRating === "") {
        this.$store
          .dispatch("submitResourceRating", ratingObj)
          .then((response) => {
            this.ratingSubmitted = true;
            this.initialRating = this.userRating;
            setTimeout(this.hideRatingSubmitted, 500);
            this.getRatings();
            this.updateAverageRating();
            console.log(response);
          })
          .catch((error) => {
            console.info(error);
          });
      } else {
        this.$store
          .dispatch("deleteResourceRating", this.$route.params.id)
          .then((response) => {
            this.$store
              .dispatch("submitResourceRating", ratingObj)
              .then((response) => {
                this.ratingSubmitted = true;
                this.initialRating = this.userRating;
                setTimeout(this.hideRatingSubmitted, 500);
                this.getRatings();
                this.updateAverageRating();
                console.log(response);
              })
              .catch((error) => {
                console.info(error);
              });
          });
      }
    },
    getResource: function (resourceId) {
      // Fetch the resource and the resource
      this.$store.dispatch("getResourceEntity", resourceId).then((entity) => {
        this.resource = entity;
        this.resource.isShared = false;
        this.$set(this.resource, 'bookmarked', ( entity.bookmarked || false ))
      });
    },
    handleBookmarkResource(resource) {
      if (!resource.bookmarked) {
        this.$store
          .dispatch("bookmarkResource", resource.id)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              resource.bookmarked = true;
            }
          });
      } else {
        this.$store
          .dispatch("deleteBookmarkResource", resource.id)
          .then((response) => {
            console.log(response);
            if (response.status === 200) {
              resource.bookmarked = false;
            }
          });
      }
    },
    getUserRating(id) {
      let ratingInfo = {
        resourceId: id,
        userId: this.$store.state.user.id,
      };
      this.$store
        .dispatch("getResourceRatingUser", ratingInfo)
        .then((response) => {
          this.userRating = response[0].stars;
          this.userRatingComment = response[0].comment;
          this.initialRating = this.userRating;
        });
    },
    showMsgDelete(resId, resTitle) {
      this.boxTwo = "";
      this.$bvModal
        .msgBoxConfirm(
          "Please confirm that you want to delete this resource.",
          {
            title: "Are you sure you want to delete " + resTitle + "?",
            size: "bg",
            buttonSize: "bg",
            okVariant: "danger",
            okTitle: "YES",
            cancelTitle: "NO",
            footerClass: "p-2",
            hideHeaderClose: false,
            centered: true,
          }
        )
        .then((value) => {
          this.boxTwo = value;
          if (this.boxTwo) {
            this.deleteResource(resId);
          } else {
          }
        })
        .catch((error) => {
          alert("An error occurred! Please refresh the page." + error);
        });
    },
    deleteResource(resourceId) {
      // Delete the resource and direct user's browser in resources list
      this.$store.dispatch("deleteResourceEntity", resourceId).then((data) => {
        this.$router.push({ name: "resources" });
      });
    },
    adjustIcon(mediaType) {
      // load the proper icon given the media type
      if (mediaType === "Image") {
        return "image";
      } else if (mediaType === "Audio") {
        return "file-audio";
      } else if (mediaType === "Linked Video") {
        return "play-circle";
      } else if (mediaType === "Website") {
        return "link";
      } else if (mediaType === "Text") {
        return "file-alt";
      } else if (mediaType === "Pdf") {
        return "file-pdf";
      } else {
        return "file-alt";
      }
    },
    adjustColor(mediaType) {
      // load the proper icon given the media type
      if (mediaType === "Image") {
        return "image";
      } else if (mediaType === "Audio") {
        return "color: #f0d6f1";
      } else if (mediaType === "Linked Video") {
        return "color: #ff6c6c";
      } else if (mediaType === "Website") {
        return "color: #95c9ff";
      } else if (mediaType === "Text") {
        return "color: #fff37a";
      } else if (mediaType === "Pdf") {
        return "color: red";
      } else {
        return "color: #fff37a";
      }
    },
    existKeywords() {
      return Object.keys(this.resource.keywords).length > 0;
    },
  },
  filters: {},
};
</script>

<style scoped>
.border-custom-lgr {
  border: 1px solid #d3d3d366;
}

#description-container {
  min-height: 80px !important;
}

.min-h-250 {
  min-height: 250px !important;
}

.col-container {
  border-left: 1px solid #d3d3d366;
  border-top: 1px solid #d3d3d366;
  border-bottom: 1px solid #d3d3d366;
  border-right: 10px solid #f7f7f7;
}

#image-container {
  min-height: 250px !important;
}
</style>



// WEBPACK FOOTER //
// src/views/ResourceView.vue